import { render, staticRenderFns } from "./InventmentAllocation.vue?vue&type=template&id=5cabf9b4&scoped=true"
import script from "./InventmentAllocation.vue?vue&type=script&lang=js"
export * from "./InventmentAllocation.vue?vue&type=script&lang=js"
import style0 from "./InventmentAllocation.vue?vue&type=style&index=0&id=5cabf9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabf9b4",
  null
  
)

export default component.exports